import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Job } from "../models/job_model";

@Injectable()
export class OpJobService {
  constructor(private http: HttpClient) {}
  setHeader() {
    let headers = new HttpHeaders();
    return headers;
  }
  myHeaders = this.setHeader();

  getAllJob() {
    let url = environment.URL + "/job/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }

  JobBySiteId(siteId) {
    let url = environment.URL + "/jobBySite/" + siteId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  jobAutoNumber() {
    let url = environment.URL + "/job/autoNumber";
    return this.http.get(url, { headers: this.myHeaders });
  }

  jobImagesForVerify(jobName: string, criteria: string, logId: any) {
    let url = environment.URL + "/job/verify/"+jobName+"/images-verify/" + criteria + '/' + logId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  jobClassForVerify(id: any) {
    let url = environment.URL + "/job/class/"+id+"/images-verify";
    return this.http.get(url, { headers: this.myHeaders });
  }

  jobUploadClassImages(formData: any, id: any) {
    let url = environment.URL + "/job/class/"+id+"/upload-images-verify";
    return this.http.post(url, formData, { headers: this.myHeaders });
  }

  jobReUploadImages(formData: any, id: any, proofcardNumber: any) {
    let url = environment.URL + "/job/proofcards/"+id+ "/" + proofcardNumber +"/upload-images";
    return this.http.post(url, formData, { headers: this.myHeaders });
  }

  JobRecordById(JobId) {
    let url = environment.URL + "/job/edit/" + JobId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  JobGetProofcardImagesById(JobId: any) {
    let url = environment.URL + "/job/proofcards-image/" + JobId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveJob(bodyParams: Job) {
    let url = environment.URL + "/job/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateJob(bodyParams: Job) {
    let url = environment.URL + "/job/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateOrderDeadlineByJob(bodyParams: Job) {
    let url = environment.URL + "/job/updateOrderDeadline";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateManagerVisibilityForJob(bodyParams: Job) {
    let url =
      environment.URL +
      "/job/visibletoManager/" +
      bodyParams.id +
      "/" +
      bodyParams.visable_to_manager;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updatePostageMandatory(bodyParams: Job) {
    let url =
      environment.URL +
      "/job/postageMandatory/" +
      bodyParams.id +
      "/" +
      bodyParams.isPostageMandatory;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateManagerCommiSion(jobId, stop_total_count) {
    let url =
      environment.URL +
      "/job/updateManagerCommission/" +
      jobId +
      "/" +
      stop_total_count;
    return this.http.get(url, { headers: this.myHeaders });
  }

  deleteJob(bodyParams: Job) {
    let url = environment.URL + "/job/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId, siteId) {
    let url =
      environment.URL +
      "/job/" +
      value +
      "/" +
      column +
      "/" +
      siteId +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearchForNurseryRelevantJobs(value, column, pageId, siteId) {
    let url =
      environment.URL +
      "/manager/job/" +
      value +
      "/" +
      column +
      "/" +
      siteId +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  import(FormData: any) {
    let url = environment.URL + "/job/import";
    return this.http.post(url, FormData, { headers: this.myHeaders });
  }

  downloadPoster(jobId) {
    let url = environment.URL + "/job/posterDownload/" + jobId;
    // window.open(url);
    return this.http.get(url, { headers: this.myHeaders });
  }

  viewPoster(jobId) {
    let url = environment.URL + "/job/posterView/" + jobId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  sendMail(jobId) {
    let url = environment.URL + "/poster/sendMail/" + jobId;
    console.log(url);
    return this.http.get(url, { headers: this.myHeaders });
  }
  sendManager(jobId) {
    let url = environment.URL + "/poster/sendManager/" + jobId;
    console.log(url);
    return this.http.get(url, { headers: this.myHeaders });
  }
  sendPosterAndManager(jobId) {
    let url = environment.URL + "/poster/sendPosterAndManager/" + jobId;
    console.log(url);
    return this.http.get(url, { headers: this.myHeaders });
  }

  proofcardDispatched(bodyParams: Job) {
    let url = environment.URL + "/job/proofcardDispatched";
    // bodyParams.proofcards_dispatched;
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  orderDispatched(bodyParams: Job) {
    let url = environment.URL + "/job/orderDispatchedNursery";
    // bodyParams.proofcards_dispatched;
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  markAsCommisionPaid(bodyParams: any) {
    let url = environment.URL + "/order/commissionPaid";
    // bodyParams.isCommissionPaid;
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateManagerCommiSionBySiteGroup(siteGroupId) {
    let url =
      environment.URL +
      "/siteGroup/updateSiteGroupManagerCommission/" +
      siteGroupId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  siteGroupCommisionPaid(bodyParams: any) {
    let url = environment.URL + "/siteGroup/commissionPaid";
    // bodyParams.isCommissionPaid;
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }
}
